import React from "react";
import { useTranslation } from "react-i18next";
import { CommandEmpty, CommandGroup, CommandItem } from "../ui";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";
import { NameAndAvatar } from "../StudentListWrapper/Grid/NameAndAvatar";
import { Student } from "@/types/Student";
import { ApolloError } from "@apollo/client";
import { AnalyticsEvent } from "@/hooks/useAnalytics";

export function SearchResult({
  students,
  error,
  setOpen,
  profileSource,
}: {
  students: Student[];
  error?: ApolloError;
  setOpen: (open: boolean) => void;
  profileSource?: string;
}) {
  const { t } = useTranslation();
  const { navToRoute } = useProtectedNavigation();

  if (error) {
    return (
      <CommandEmpty>
        <p className="px-4 text-red-500">{t("search.error")}</p>
      </CommandEmpty>
    );
  }

  if (!students?.length) {
    return (
      <CommandEmpty>
        <p className="px-4 text-muted-foreground">
          {t("search.noStudentsFound")}
        </p>
      </CommandEmpty>
    );
  }

  return (
    <CommandGroup className="p-1">
      {students.map((student) => (
        <CommandItem
          key={student.id}
          onSelect={(id) => {
            navToRoute("student", { studentId: id }, {}, {
              analyticsEvent: profileSource ? AnalyticsEvent.OpenedProfile : undefined,
              analyticsProperties: profileSource ? { Source: profileSource } : undefined,
            });
            setOpen(false);
          }}
          value={student.id}
          className="cursor-pointer"
        >
          <NameAndAvatar
            name={student.studentOrganizationStatus?.name}
            imageUrl={student.imageUrl}
            avatarSize="size-6"
            nameClass="text-foreground"
            avatarClass="border-2 border-background"
          />
        </CommandItem>
      ))}
    </CommandGroup>
  );
}
